import { Component, Input } from '@angular/core'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'
import { ChatBotService } from '../../../services/chat-bot/chat-bot.service'

@Component({
  selector: 'mb-consent-modal',
  templateUrl: './consent-modal.component.html',
  styleUrls: ['./consent-modal.component.scss']
})
export class ConsentModalComponent {

  @Input() ucId: string | undefined
  @Input() ucServiceId: string | undefined
  @Input() ucService: string | undefined

  constructor (private modal: NgbActiveModal,
               private chatBotService: ChatBotService) {
  }

  close (accepted: boolean) {
    if (accepted) {
      this.chatBotService.setShowWidgetWithNextBotAction(true)
    }
    this.modal.close()
  }
}
